import { RefObject, useEffect } from 'react';

const DOCUMENT_SCROLL_DISABLE_CLASS = 'DOCUMENT_SCROLL_DISABLE';

/**
 * Блокировка скролла модалкой добавляет overflow: hidden на <html>, что меняет
 * containing block для sticky-элементов и заставляет их "уезжать" поверх модалки.
 * Пока скролл заблокирован — навешивает на элемент переданный CSS-класс
 * (в нём должен быть задан position: fixed с тем же top, что и у sticky).
 */
export const useFixStickyDuringScrollLock = (
  elementRef: RefObject<HTMLElement | null>,
  lockedClassName: string,
): void => {
  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const syncScrollLockedClass = () => {
      const isScrollDisabled = document.documentElement.classList.contains(DOCUMENT_SCROLL_DISABLE_CLASS);

      element.classList.toggle(lockedClassName, isScrollDisabled);
    };

    const observer = new MutationObserver(syncScrollLockedClass);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, [elementRef, lockedClassName]);
};
